module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "180pt",
      "font-weight": "bold"
    }
  }, [_vm._v("‘ We are the Pilgrims, master; we shall go")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("Always a little further; it may be")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("Beyond that last blue mountain barred with snow")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("Across that angry or that glimmering sea…’")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("– Inscription on the clock tower at Stirling Lines")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda61350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 78
// module chunks = 0